// Адрес для обращений о данных и претензий: политика, соглашение, реквизиты.
export const PRIVACY_CONTACT_EMAIL = "abykov.engineer@outlook.com";
